import store from '@/state/store'
const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

import status from './status'
import TransitionToCancelModalVue from '@/router/views/delivery/components/TransitionToCancelModal'
import TransitionToRescheduleModal from '@/router/views/delivery/components/TransitionToRescheduleModal'

/**
 * NOTE:
 * to add additional POST body payload,
 * use additionalPayload key, all the properties
 * will be merged with the default payload
 * Dikonfirmasi: [
 *   {
 *     status: status.CANCELED,
 *     customModalTransition: TransitionToCancelModal,
 *   },
 * ],
 */

/*
  Should use one function to recieve deliveryOrder object and return available transition statuses from that delivery order state
  Example: 
  function getAvailableTransitionStatuses(deliveryOrder, ...*additional info*) {
    return [...]
  }
*/

const statusTransitions = (
  isSubscribeVMS = false,
  isRequestedToVendor = false,
  isFromVendorRequest = false,
  isPickUp = false,
  isTransit = false,
  hasTmsMarketingFlag = false,
) => {
  return {
    /* DRAFT */
    Draf: getDraftTransitionStatuses(hasTmsMarketingFlag),

    /* CONFIRMED */
    Dikonfirmasi: getConfirmedTransitionStatuses(isSubscribeVMS, isFromVendorRequest),

    /* WAITING_FOR_VENDOR */
    'Menunggu Vendor': [],

    /* ACCEPTED_BY_VENDOR */
    'Diterima Vendor': [],

    /* REJECTED_BY_VENDOR */
    Ditolak: getRejectedTransitionStatuses(isSubscribeVMS),

    /* SCHEDULED */
    Dijadwalkan: getScheduledTransitionStatuses(isRequestedToVendor, isFromVendorRequest),

    /* RESCHEDULED */
    'Dijadwalkan Ulang': getRescheduledTransitionStatuses(isRequestedToVendor, isFromVendorRequest),

    /* STARTED */
    Dijalankan: getStartedTransitionStatuses(isRequestedToVendor, isFromVendorRequest, isTransit),

    /* PICKUP */
    Diambil: getPickUpTransitionStatuses(
      isRequestedToVendor,
      isFromVendorRequest,
      isTransit,
    ),

    /* TRANSIT */
    'Sedang Transit': [],

    /* DELIVERED */
    Terkirim: [],

    /* CANCELED */
    Dibatalkan: [],
  }
}

function getDraftTransitionStatuses(hasTmsMarketingFlag = false) {
  if (hasTmsMarketingFlag) {
    return [
      { status: status.CONFIRMED },
    ]
  }

  return [
    { status: status.CONFIRMED },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    },
  ]
}

function getConfirmedTransitionStatuses(isSubscribeVMS = false, isFromVendorRequest = false) {
  const confirmedStatuses = []

  if (isSubscribeVMS && !isFromVendorRequest) {
    confirmedStatuses.push({
      status: status.WAITING_FOR_VENDOR,
    })
  }

  if (!isFromVendorRequest) {
    confirmedStatuses.push({
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    })
  }

  return confirmedStatuses
}

function getScheduledTransitionStatuses(isRequestedToVendor = false, isFromVendorRequest = false) {
  if (isRequestedToVendor || isFromVendorRequest) {
    return []
  }

  return [
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    },
  ]
}

function getStartedTransitionStatuses(
  isRequestedToVendor = false,
  isFromVendorRequest = false,
  isTransit = false
) {
  if (isRequestedToVendor || isFromVendorRequest || isTransit) {
    return []
  }

  return [
    {
      status: status.RESCHEDULED,
      customModalTransition: TransitionToRescheduleModal,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    },
  ]
}

function getRejectedTransitionStatuses(isSubscribeVMS = false) {
  const rejectedStatuses = []

  if (isSubscribeVMS) {
    rejectedStatuses.push({
      status: status.WAITING_FOR_VENDOR,
    })
  }

  return rejectedStatuses
}

function getPickUpTransitionStatuses(isRequestedToVendor = false, isFromVendorRequest = false, isTransit = false) {
  if (
    isRequestedToVendor ||
    isFromVendorRequest ||
    isTransit
  ) {
    return []
  }
  return [
    {
      status: status.RESCHEDULED,
      customModalTransition: TransitionToRescheduleModal,
    },
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    },
  ]
}

function getRescheduledTransitionStatuses(isRequestedToVendor, isFromVendorRequest) {
  if (isRequestedToVendor || isFromVendorRequest) {
    return []
  }
  return [
    {
      status: status.CANCELED,
      customModalTransition: TransitionToCancelModalVue,
      isRedText: true,
    },
  ]
}

export default statusTransitions
